/**
 * ST4S phase 3 — pure view/decision helpers for PendingApprovalPage.
 *
 * Kept in a separate (neverland-free) module so they are testable under the
 * reporting vitest env ('node', no DOM) without importing the Neverland
 * component — consistent with the repo's extracted-decision-logic pattern.
 */

/** Helpdesk address shown as the fallback contact on the pending screen. */
export const HELPDESK_EMAIL = 'helpdesk@resilientyouth.org';

/**
 * Dynamic content the pending-approval screen renders.
 *
 * `contactEmails` is derived from auth.userData.contacts[] — each non-empty,
 * trimmed `.email` (displayed as stored). When no contacts exist the component
 * falls back to just the helpdesk line.
 *
 * @param {object} auth
 * @returns {{ school: string, heading: string, logoutLabel: string, contactEmails: string[], helpdeskEmail: string }}
 */
export function pendingApprovalView(auth) {
  const contacts = (auth && auth.userData && Array.isArray(auth.userData.contacts))
    ? auth.userData.contacts
    : [];
  const contactEmails = contacts
    .map(c => (c && typeof c.email === 'string' ? c.email.trim() : ''))
    .filter(email => email.length > 0);

  return {
    school: (auth && auth.userData && auth.userData.name) || 'this organisation',
    heading: 'Access Pending Approval',
    logoutLabel: 'Back to Login',
    contactEmails,
    helpdeskEmail: HELPDESK_EMAIL
  };
}

/**
 * Auth state produced when the user logs out from the pending screen — clears
 * the pending session (mfaVerified stays false so no data session loads).
 *
 * @param {object} prev
 */
export function pendingApprovalLogout(prev) {
  return { ...prev, mfaPage: null, mfaVerified: false, userData: null };
}
